const UPLOAD_PATH_PREFIX = '/uploads/'

function normalizePath(url: string): string {
  return url.startsWith('/') ? url : `/${url}`
}

/** Display URL for <img> — backend uploads use API origin when frontend/API are split. */
export function resolveMediaUrl(
  url: string | null | undefined,
  apiOrigin?: string,
): string {
  if (!url) return '/placeholder-product.jpg'
  if (/^https?:\/\//i.test(url) || url.startsWith('data:')) return url

  const path = normalizePath(url)
  if (path.startsWith(UPLOAD_PATH_PREFIX) && apiOrigin) {
    return `${apiOrigin.replace(/\/$/, '')}${path}`
  }

  return path
}

/** Absolute URL for SEO meta / JSON-LD (og:image etc.). */
export function resolveAbsoluteMediaUrl(
  url: string | null | undefined,
  siteUrl: string,
  apiOrigin?: string,
): string {
  const resolved = resolveMediaUrl(url, apiOrigin)
  if (/^https?:\/\//i.test(resolved)) return resolved
  return `${siteUrl.replace(/\/$/, '')}${resolved}`
}

/** Guess icon MIME from path/URL for <link rel="icon" type="...">. */
export function guessIconMimeType(url: string | null | undefined): string | undefined {
  if (!url) return undefined
  const pathOnly = url.split('?')[0]?.split('#')[0] || url
  const ext = pathOnly.includes('.')
    ? pathOnly.slice(pathOnly.lastIndexOf('.')).toLowerCase()
    : ''
  switch (ext) {
    case '.ico':
      return 'image/x-icon'
    case '.png':
      return 'image/png'
    case '.webp':
      return 'image/webp'
    case '.svg':
      return 'image/svg+xml'
    case '.jpg':
    case '.jpeg':
      return 'image/jpeg'
    case '.gif':
      return 'image/gif'
    default:
      return undefined
  }
}
